import { cnl } from "csi/typings";

/**
 * Return the revision number of a given revision
 * @param revisionUrl The cnl of the revision who's revision number is being determined
 * @param revisionUrls The cnls of the all the revisions for this item
 * @param revisionName The name of the revision
 */
export function getRevisionNumber(revisionUrl: cnl, revisionUrls: cnl[], revisionName?: string): number {
	const revisionNumber = parseInt(revisionName);
	return isNaN(revisionNumber) ? (revisionUrls.indexOf(revisionUrl) + 1) : revisionNumber;
}